<template>
    <div>
        <el-dialog top="5%" title="新增" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="项目名称" prop="FName">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                 <el-form-item label="项目模板" prop="FMouldId"> 
                    <sy-select v-model="form.FMouldId" @change="changemould"
                               optionData="server/business/ProjectMould.ashx?cmd=GetOptions">
                    </sy-select>
                </el-form-item>
                 <el-form-item label="型号" prop="FDutyTypeId" v-if="false"> 
                    <sy-select v-model="form.FDutyTypeId"
                               optionData="server/business/DutyMould.ashx?cmd=GetModelOptions">
                    </sy-select>
                </el-form-item>
                 <el-form-item label="指派人" prop="FAssignUserId"> 
                    <sy-select v-model="form.FAssignUserId"
                               optionData="server/system/User.ashx?cmd=GetUserOptions">
                    </sy-select>
                </el-form-item>
                 <el-form-item label="开始时间" prop="FStartTime" >
                    <el-date-picker type="datetime" placeholder="选择时间" v-model="form.FStartTime" style="width: 100%;"></el-date-picker>
                </el-form-item>
                 <el-form-item label="结束时间" prop="FEndTime" >
                    <el-date-picker type="datetime" placeholder="选择日期" v-model="form.FEndTime" style="width: 100%;"></el-date-picker>
                </el-form-item>
                 <el-form-item label="计划数量" prop="FPlanNum"> 
                     <el-input type="number" v-model="form.FPlanNum"></el-input>
                </el-form-item>
                
                  <el-form-item label="进度(%)" prop="FProgress"> 
                     <el-input type="number" v-model="form.FProgress"></el-input>
                </el-form-item>
                  <el-form-item label="项目说明">
                    <el-input type="textarea" v-model="form.FNote"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
    </div>
</template>

<script>
    import util from '../../common/util'
    export default {
        data() {
            return {
                form: {},
                rules: {
                    FName: [{required: true,message: '项目名称', trigger: 'blur'}],
                    FMouldId: [{required: true,message: '项目分类', trigger: 'blur'}],
                    FDutyTypeId: [{required: true,message: '型号', trigger: 'blur'}],
                    FAssignUserId: [{required: true,message: '指派人', trigger: 'blur'}],
                    FStartTime: [{required: true,message: '开始时间', trigger: 'blur'}],
                    FEndTime: [{required: true,message: '结束时间', trigger: 'blur'}]
                },
                loading:false,
                editFormVisible:false
            }
        },
        methods: {
            _openEdit(record) {
                this.editFormVisible = true;
                this.form = Object.assign({},record);
            },
            _openAdd(record) {
                this.editFormVisible = true;
                this.form = {FID:0,FMouldId:0,FLeader:0,FDutyTypeId:0,FPlanNum:0,FProgress:0,FStatus:0,FAssignUserId:0};
            },
            switchLoading(flag){
                this.loading = flag;
            },
            save:function () {
               
                if(this.form.FStartTime>this.form.FEndTime){
                      util.msgWarning("开始时间不能大于结束时间")
                      return
                }
                //设置负责人和指派人为同一人
                this.form.FLeader = this.form.FAssignUserId

                util.saveForm("server/business/Project.ashx?cmd=Save",this.$refs.form,this.form,this.switchLoading,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
                
            },
            changemould(val,record){
                 this.form.FLeader = record.FLeader
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Project_Edit.vue